import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import ValidacionesScreen from './Screen';
import { MaestroValidaciones, ValidacionesAdapter } from '../../../../../../infraestructure/persistence/rest/ValidacionesAdapter';
import { useNotifications } from '../../../../../../shared/hooks/Notifications';

export const ValidacionesContainer = () => {

	const api = new ValidacionesAdapter();
	const {resultError, exceptionError, launchNotification}  = useNotifications();
	let [ validaciones, setValidaciones ] = useState<any>([]);
	let result: any;

	useEffect(() => {
		getValidaciones();
	}, []);

	useEffect(() => {}, [ validaciones ]);

	const getValidaciones = async () => {
		try {
			result = await api.ListarMaestroValidaciones();
			if(result.data && result.data!=="")
			{
				setValidaciones([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const createValidacion = async (validacion: any) => {
		try {
			const result:any = await api.CrearMaestroValidacion(validacion);
			if(result.data && result.data!=="")
			{
				setValidaciones([ ...validaciones,...result.data ] || []);
				launchNotification({type:"success",title:"Creación",message:"Se ha creado un nuevo registro en el maestro de Validaciones."})
			}else{
				resultError()
			}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	};


	const deleteValidacion = async (validacion: any) => {
		try {
			result = await api.EliminarValidacion(validacion.año);
			if(result.data && result.data!=="")
			{
				let pos = validaciones.findIndex((u: any) => u.año === validacion.año);
				let newData = [ ...validaciones ];
				newData.splice(pos, 1);
				setValidaciones([ ...newData ] || []);
				launchNotification({type:"success",title:"Eliminación",message:"Se ha eliminado un registro en el maestro de Validaciones."})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const updateValidacion = async (añoOLD:Number,validacion: any) => {
		try {
			result = await api.ModificarValidacion(añoOLD,validacion);
			if(result.data && result.data!=="")
			{
				let pos = validaciones.findIndex((u: any) => u.año === añoOLD);
				let newData = [ ...validaciones ];
				newData[pos] = result.data[0];
				setValidaciones([ ...newData ] || []);
				launchNotification({type:"success",title:"Modificación",message:"Se ha modificado un registro en el maestro de Validaciones."})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	return (
		<>
		<ValidacionesScreen
			data={validaciones}
			handleCreate={createValidacion}
			handleRemove={deleteValidacion}
			handleUpdate={updateValidacion}
		/>
		</>
	);
};

export default ValidacionesContainer;
